<template>
  <v-container fluid>
    <ModalUsuario
      :modalUsuario="modalUsuario"
      :editUsuario="editUsuarioObj"
      @close="closeModalUsuario"
    />
    <Grid
      title="Usuários"
      :headers="headers"
      :items="usuarios"
      @novo="modalUsuario = true"
      @edit="editUsuario"
      @destroy="destroyUsuario"
      @atualiza="getUsuarios"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Grid from '@/components/shared/Grid';
import ModalUsuario from '@/components/usuario/ModalUsuario';

export default {
  name: 'Usuarios',
  data: () => ({
    modalUsuario: false,
    editUsuarioObj: null,
    headers: [
      {
        text: 'Nome',
        align: 'start',
        value: 'nome',
      },
      { text: 'Status', value: 'status' },
      { text: 'Ações', value: 'actions', sortable: false },
    ],
  }),
  components: {
    Grid,
    ModalUsuario
  },
  computed: {
    ...mapGetters(['usuarios'])
  },
  methods: {
    ...mapActions(['fetchUsuarios', 'deleteUsuario']),
    closeModalUsuario() {
      this.editUsuarioObj = null;
      this.modalUsuario = false;
    },
    getUsuarios() {
      this.fetchUsuarios({ limit: 999 });
    },
    editUsuario(usuario) {
      this.editUsuarioObj = { ...usuario };
      this.modalUsuario = true;
    },
    destroyUsuario(usuario) {
      if (confirm(`Tem certeza que deseja excluir o usuario: ${usuario.nome}?`)) {
        this.deleteUsuario(usuario._id);
      }
    }
  },
  created() {
    this.getUsuarios();
  }
}
</script>

<style>

</style>